export default {
  'entities.aiModel.fields.created_dt': 'Created at',
  'entities.aiModel.fields.deleted_dt': 'Deleted at',
  'entities.aiModel.fields.id': 'Identifier',
  'entities.aiModel.fields.model_path': 'Model path',
  'entities.aiModel.fields.name': 'Name',
  'entities.aiModel.fields.parent': 'Parent',
  'entities.aiModel.fields.parent_id': 'Parent ID',
  'entities.aiModel.fields.updated_dt': 'Updated at',
  'entities.aiModel.title': 'AI model',
  'entities.application.fields.application': 'Application',
  'entities.application.fields.application_id': 'Application ID',
  'entities.application.fields.created_dt': 'Created at',
  'entities.application.fields.deleted_dt': 'Deleted at',
  'entities.application.fields.details': 'Details (JSON)',
  'entities.application.fields.id': 'Identifier',
  'entities.application.fields.updated_dt': 'Updated at',
  'entities.application.title': 'Application',
  'entities.applicationToken.fields.access_token': 'Access token',
  'entities.applicationToken.fields.access_token_expired_time': 'Access token expiry',
  'entities.applicationToken.fields.created_dt': 'Created at',
  'entities.applicationToken.fields.id': 'Identifier',
  'entities.applicationToken.fields.refresh_token': 'Refresh token',
  'entities.applicationToken.fields.refresh_token_expired_time': 'Refresh token expiry',
  'entities.applicationToken.fields.user_id': 'User ID',
  'entities.applicationToken.title': 'Application token',
  'entities.authLogin.fields.email': 'Email',
  'entities.authLogin.fields.password': 'Password',
  'entities.authLogin.title': 'Login payload',
  'entities.authRegister.fields.email': 'Email',
  'entities.authRegister.fields.name': 'Name',
  'entities.authRegister.fields.parent_id': 'Parent ID',
  'entities.authRegister.fields.password': 'Password',
  'entities.authRegister.title': 'Registration payload',
  'entities.authResponse.fields.access_token': 'Access token',
  'entities.authResponse.fields.refresh_token': 'Refresh token',
  'entities.authResponse.fields.token_type': 'Token type',
  'entities.authResponse.fields.user': 'User',
  'entities.authResponse.title': 'Auth Response',
  'entities.brokerEvent.fields.created_dt': 'Created at',
  'entities.brokerEvent.fields.deleted_dt': 'Deleted at',
  'entities.brokerEvent.fields.id': 'Identifier',
  'entities.brokerEvent.fields.name': 'Name',
  'entities.brokerEvent.fields.slug': 'Slug',
  'entities.brokerEvent.fields.updated_dt': 'Updated at',
  'entities.brokerEvent.title': 'Broker event',
  'entities.common.fields.created_dt': 'Created at',
  'entities.common.fields.default': 'Default',
  'entities.common.fields.deleted_dt': 'Deleted at',
  'entities.common.fields.detail_scheduler_id': 'Scheduler detail ID',
  'entities.common.fields.details': 'Details (JSON)',
  'entities.common.fields.email': 'Email',
  'entities.common.fields.id': 'Identifier',
  'entities.common.fields.login': 'Login (email)',
  'entities.common.fields.name': 'Name',
  'entities.common.fields.npp': 'Sort order',
  'entities.common.fields.organization_id': 'Subject ID',
  'entities.common.fields.parent_id': 'Parent ID',
  'entities.common.fields.password': 'Password',
  'entities.common.fields.permission_id': 'Permission ID',
  'entities.common.fields.pipeline_id': 'Pipeline ID',
  'entities.common.fields.position_id': 'Position ID',
  'entities.common.fields.schema_pipeline': 'Pipeline schema',
  'entities.common.fields.service_id': 'Service ID',
  'entities.common.fields.slug': 'Slug',
  'entities.common.fields.status': 'Status',
  'entities.common.fields.status_id': 'Status ID',
  'entities.common.fields.subject_id': 'Subject ID',
  'entities.common.fields.token_type': 'Token type',
  'entities.common.fields.type': 'Type',
  'entities.common.fields.updated_dt': 'Updated at',
  'entities.common.fields.user': 'User',
  'entities.common.fields.user_id': 'User ID',
  'entities.common.fields.version_id': 'Version ID',
  'entities.communication.fields.create_user': 'Created by user',
  'entities.communication.fields.create_user_id': 'Created by user ID',
  'entities.communication.fields.created_dt': 'Created at',
  'entities.communication.fields.deleted_dt': 'Deleted at',
  'entities.communication.fields.id': 'Identifier',
  'entities.communication.fields.name': 'Name',
  'entities.communication.fields.slug': 'Slug',
  'entities.communication.fields.subject_communication': 'Communication subject type',
  'entities.communication.fields.subject_communication_id': 'Communication subject ID',
  'entities.communication.fields.updated_dt': 'Updated at',
  'entities.communication.title': 'Communication',
  'entities.communicationDetail.fields.communication': 'Communication',
  'entities.communicationDetail.fields.communication_id': 'Communication ID',
  'entities.communicationDetail.fields.created_dt': 'Created at',
  'entities.communicationDetail.fields.deleted_dt': 'Deleted at',
  'entities.communicationDetail.fields.folder': 'Folder',
  'entities.communicationDetail.fields.folder_id': 'Folder ID',
  'entities.communicationDetail.fields.id': 'Identifier',
  'entities.communicationDetail.fields.updated_dt': 'Updated at',
  'entities.communicationDetail.fields.view': 'View',
  'entities.communicationDetail.title': 'Communication detail',
  'entities.communicationFolder.fields.created_dt': 'Created at',
  'entities.communicationFolder.fields.deleted_dt': 'Deleted at',
  'entities.communicationFolder.fields.id': 'Identifier',
  'entities.communicationFolder.fields.name': 'Name',
  'entities.communicationFolder.fields.org_structure': 'Org structure',
  'entities.communicationFolder.fields.org_structure_id': 'Org structure ID',
  'entities.communicationFolder.fields.organization': 'Organization',
  'entities.communicationFolder.fields.organization_id': 'Subject ID',
  'entities.communicationFolder.fields.parent': 'Parent',
  'entities.communicationFolder.fields.parent_id': 'Parent ID',
  'entities.communicationFolder.fields.slug': 'Slug',
  'entities.communicationFolder.fields.updated_dt': 'Updated at',
  'entities.communicationFolder.title': 'Communication folder',
  'entities.communicationHistory.fields.communication': 'Communication',
  'entities.communicationHistory.fields.created_dt': 'Created at',
  'entities.communicationHistory.fields.deleted_dt': 'Deleted at',
  'entities.communicationHistory.fields.history_running_pipelines': 'Pipeline run history',
  'entities.communicationHistory.fields.id': 'Identifier',
  'entities.communicationHistory.fields.updated_dt': 'Updated at',
  'entities.communicationHistory.fields.version': 'Version',
  'entities.communicationHistory.fields.version_id': 'Version ID',
  'entities.communicationHistory.title': 'Communication history',
  'entities.communicationPermission.fields.communication': 'Communication',
  'entities.communicationPermission.fields.created_dt': 'Created at',
  'entities.communicationPermission.fields.deleted_dt': 'Deleted at',
  'entities.communicationPermission.fields.id': 'Identifier',
  'entities.communicationPermission.fields.org_structures': 'Org structures',
  'entities.communicationPermission.fields.org_structures_id': 'Org structure ID',
  'entities.communicationPermission.fields.permission': 'Permission',
  'entities.communicationPermission.fields.permission_id': 'Permission ID',
  'entities.communicationPermission.fields.position': 'Position',
  'entities.communicationPermission.fields.position_id': 'Position ID',
  'entities.communicationPermission.fields.updated_dt': 'Updated at',
  'entities.communicationPermission.fields.view': 'View',
  'entities.communicationPermission.fields.view_id': 'View ID',
  'entities.communicationPermission.title': 'Communication permission',
  'entities.communicationStrategy.fields.communication': 'Communication',
  'entities.communicationStrategy.fields.created_dt': 'Created at',
  'entities.communicationStrategy.fields.deleted_dt': 'Deleted at',
  'entities.communicationStrategy.fields.id': 'Identifier',
  'entities.communicationStrategy.fields.provider_context_classification': 'Provider context classification',
  'entities.communicationStrategy.fields.provider_context_classification_id': 'Provider context classification ID',
  'entities.communicationStrategy.fields.updated_dt': 'Updated at',
  'entities.communicationStrategy.fields.version': 'Version',
  'entities.communicationStrategy.fields.version_id': 'Version ID',
  'entities.communicationStrategy.title': 'Communication strategy',
  'entities.communicationSubject.fields.classification_id': 'Classification ID',
  'entities.communicationSubject.fields.created_dt': 'Created at',
  'entities.communicationSubject.fields.deleted_dt': 'Deleted at',
  'entities.communicationSubject.fields.id': 'Identifier',
  'entities.communicationSubject.fields.name': 'Name',
  'entities.communicationSubject.fields.organization': 'Organization',
  'entities.communicationSubject.fields.organization_id': 'Subject ID',
  'entities.communicationSubject.fields.slug': 'Slug',
  'entities.communicationSubject.fields.type': 'Type',
  'entities.communicationSubject.fields.type_id': 'Type ID',
  'entities.communicationSubject.fields.updated_dt': 'Updated at',
  'entities.communicationSubject.title': 'Communication subject',
  'entities.communicationVersion.fields.communication': 'Communication',
  'entities.communicationVersion.fields.create_user_id': 'Created by user ID',
  'entities.communicationVersion.fields.created_dt': 'Created at',
  'entities.communicationVersion.fields.default': 'Default',
  'entities.communicationVersion.fields.deleted_dt': 'Deleted at',
  'entities.communicationVersion.fields.id': 'Identifier',
  'entities.communicationVersion.fields.name': 'Name',
  'entities.communicationVersion.fields.npp': 'Sort order',
  'entities.communicationVersion.fields.pipeline': 'Pipeline',
  'entities.communicationVersion.fields.pipeline_id': 'Pipeline ID',
  'entities.communicationVersion.fields.updated_dt': 'Updated at',
  'entities.communicationVersion.title': 'Communication version',
  'entities.communicationView.fields.created_dt': 'Created at',
  'entities.communicationView.fields.deleted_dt': 'Deleted at',
  'entities.communicationView.fields.id': 'Identifier',
  'entities.communicationView.fields.name': 'Name',
  'entities.communicationView.fields.organization': 'Organization',
  'entities.communicationView.fields.organization_id': 'Subject ID',
  'entities.communicationView.fields.slug': 'Slug',
  'entities.communicationView.fields.updated_dt': 'Updated at',
  'entities.communicationView.title': 'Communication view',
  'entities.contextClassifier.fields.created_dt': 'Created at',
  'entities.contextClassifier.fields.deleted_dt': 'Deleted at',
  'entities.contextClassifier.fields.id': 'Identifier',
  'entities.contextClassifier.fields.name': 'Name',
  'entities.contextClassifier.fields.organization': 'Organization',
  'entities.contextClassifier.fields.organization_id': 'Subject ID',
  'entities.contextClassifier.fields.slug': 'Slug',
  'entities.contextClassifier.fields.updated_dt': 'Updated at',
  'entities.contextClassifier.title': 'Context classifier',
  'entities.contextData.fields.created_dt': 'Created at',
  'entities.contextData.fields.data_key': 'Data key',
  'entities.contextData.fields.deleted_dt': 'Deleted at',
  'entities.contextData.fields.id': 'Identifier',
  'entities.contextData.fields.name': 'Name',
  'entities.contextData.fields.source': 'Source',
  'entities.contextData.fields.storage': 'Storage',
  'entities.contextData.fields.storage_id': 'Storage ID',
  'entities.contextData.fields.updated_dt': 'Updated at',
  'entities.contextData.fields.version': 'Version',
  'entities.contextData.fields.version_id': 'Version ID',
  'entities.contextData.title': 'Context data item',
  'entities.contextPipeline.fields.created_dt': 'Created at',
  'entities.contextPipeline.fields.data': 'Data',
  'entities.contextPipeline.fields.data_id': 'Data ID',
  'entities.contextPipeline.fields.deleted_dt': 'Deleted at',
  'entities.contextPipeline.fields.id': 'Identifier',
  'entities.contextPipeline.fields.name': 'Name',
  'entities.contextPipeline.fields.pipeline': 'Pipeline',
  'entities.contextPipeline.fields.pipeline_id': 'Pipeline ID',
  'entities.contextPipeline.fields.provider': 'Provider',
  'entities.contextPipeline.fields.storage': 'Storage',
  'entities.contextPipeline.fields.storage_id': 'Storage ID',
  'entities.contextPipeline.fields.updated_dt': 'Updated at',
  'entities.contextPipeline.title': 'Context pipeline',
  'entities.contextStorage.fields.created_dt': 'Created at',
  'entities.contextStorage.fields.deleted_dt': 'Deleted at',
  'entities.contextStorage.fields.id': 'Identifier',
  'entities.contextStorage.fields.name': 'Name',
  'entities.contextStorage.fields.organization': 'Organization',
  'entities.contextStorage.fields.organization_id': 'Subject ID',
  'entities.contextStorage.fields.provider': 'Provider',
  'entities.contextStorage.fields.updated_dt': 'Updated at',
  'entities.contextStorage.fields.version': 'Version',
  'entities.contextStorage.fields.version_id': 'Version ID',
  'entities.contextStorage.title': 'Context storage',
  'entities.dataPipeline.fields.created_dt': 'Created at',
  'entities.dataPipeline.fields.deleted_dt': 'Deleted at',
  'entities.dataPipeline.fields.id': 'Identifier',
  'entities.dataPipeline.fields.name': 'Name',
  'entities.dataPipeline.fields.organization': 'Organization',
  'entities.dataPipeline.fields.organization_id': 'Subject ID',
  'entities.dataPipeline.fields.type_param_service_id': 'Service params template ID',
  'entities.dataPipeline.fields.updated_dt': 'Updated at',
  'entities.dataPipeline.title': 'Data pipeline',
  'entities.dataPipelineDetail.fields.created_dt': 'Created at',
  'entities.dataPipelineDetail.fields.deleted_dt': 'Deleted at',
  'entities.dataPipelineDetail.fields.environment': 'Environment',
  'entities.dataPipelineDetail.fields.id': 'Identifier',
  'entities.dataPipelineDetail.fields.input_params': 'Input parameters',
  'entities.dataPipelineDetail.fields.output_params': 'Output parameters',
  'entities.dataPipelineDetail.fields.test_pipeline': 'Test pipeline',
  'entities.dataPipelineDetail.fields.updated_dt': 'Updated at',
  'entities.dataPipelineDetail.title': 'Data pipeline detail',
  'entities.dependentVersionService.fields.created_dt': 'Created at',
  'entities.dependentVersionService.fields.deleted_dt': 'Deleted at',
  'entities.dependentVersionService.fields.dependent': 'Dependency',
  'entities.dependentVersionService.fields.id': 'Identifier',
  'entities.dependentVersionService.fields.updated_dt': 'Updated at',
  'entities.dependentVersionService.fields.version': 'Version',
  'entities.dependentVersionService.title': 'Dependent service version',
  'entities.detailScheduler.fields.created_dt': 'Created at',
  'entities.detailScheduler.fields.deleted_dt': 'Deleted at',
  'entities.detailScheduler.fields.id': 'Identifier',
  'entities.detailScheduler.fields.run_dt': 'Run time',
  'entities.detailScheduler.fields.scheduler': 'Scheduler',
  'entities.detailScheduler.fields.updated_dt': 'Updated at',
  'entities.detailScheduler.title': 'Scheduler run detail',
  'entities.division.fields.created_dt': 'Created at',
  'entities.division.fields.deleted_dt': 'Deleted at',
  'entities.division.fields.details': 'Details (JSON)',
  'entities.division.fields.division': 'Division',
  'entities.division.fields.division_id': 'Division ID',
  'entities.division.fields.id': 'Identifier',
  'entities.division.fields.updated_dt': 'Updated at',
  'entities.division.title': 'Division',
  'entities.groupContextClassifier.fields.classifier': 'Classifier',
  'entities.groupContextClassifier.fields.classifier_id': 'Classifier ID',
  'entities.groupContextClassifier.fields.created_dt': 'Created at',
  'entities.groupContextClassifier.fields.deleted_dt': 'Deleted at',
  'entities.groupContextClassifier.fields.id': 'Identifier',
  'entities.groupContextClassifier.fields.parent_classifier': 'Parent classifier',
  'entities.groupContextClassifier.fields.parent_classifier_id': 'Parent classifier ID',
  'entities.groupContextClassifier.fields.updated_dt': 'Updated at',
  'entities.groupContextClassifier.title': 'Context classifier group',
  'entities.historyRunningPipeline.fields.created_dt': 'Created at',
  'entities.historyRunningPipeline.fields.deleted_dt': 'Deleted at',
  'entities.historyRunningPipeline.fields.environment': 'Environment',
  'entities.historyRunningPipeline.fields.exit_dt': 'Exit time',
  'entities.historyRunningPipeline.fields.id': 'Identifier',
  'entities.historyRunningPipeline.fields.input_params': 'Input parameters',
  'entities.historyRunningPipeline.fields.output_params': 'Output parameters',
  'entities.historyRunningPipeline.fields.pipeline': 'Pipeline',
  'entities.historyRunningPipeline.fields.run_dt': 'Run time',
  'entities.historyRunningPipeline.fields.schema': 'Schema pipeline',
  'entities.historyRunningPipeline.fields.schema_id': 'Schema pipeline ID',
  'entities.historyRunningPipeline.fields.updated_dt': 'Updated at',
  'entities.historyRunningPipeline.fields.user_id': 'User ID',
  'entities.historyRunningPipeline.title': 'Pipeline run history',
  'entities.historyRunningStreamPipeline.fields.created_dt': 'Created at',
  'entities.historyRunningStreamPipeline.fields.deleted_dt': 'Deleted at',
  'entities.historyRunningStreamPipeline.fields.exit_dt': 'Exit time',
  'entities.historyRunningStreamPipeline.fields.id': 'Identifier',
  'entities.historyRunningStreamPipeline.fields.run_dt': 'Run time',
  'entities.historyRunningStreamPipeline.fields.schema': 'Schema pipeline',
  'entities.historyRunningStreamPipeline.fields.schema_id': 'Schema pipeline ID',
  'entities.historyRunningStreamPipeline.fields.stream_params': 'Stream parameters',
  'entities.historyRunningStreamPipeline.fields.updated_dt': 'Updated at',
  'entities.historyRunningStreamPipeline.title': 'Stream pipeline run history',
  'entities.individual.fields.created_dt': 'Created at',
  'entities.individual.fields.deleted_dt': 'Deleted at',
  'entities.individual.fields.details': 'Details (JSON)',
  'entities.individual.fields.id': 'Identifier',
  'entities.individual.fields.subject': 'Subject',
  'entities.individual.fields.subject_id': 'Subject ID',
  'entities.individual.fields.updated_dt': 'Updated at',
  'entities.individual.title': 'Individual',
  'entities.jwtToken.fields.access_token': 'Access token',
  'entities.jwtToken.fields.access_token_expired_time': 'Access token expiry',
  'entities.jwtToken.fields.created_dt': 'Created at',
  'entities.jwtToken.fields.deleted_dt': 'Deleted at',
  'entities.jwtToken.fields.id': 'Identifier',
  'entities.jwtToken.fields.refresh_token': 'Refresh token',
  'entities.jwtToken.fields.refresh_token_expired_time': 'Refresh token expiry',
  'entities.jwtToken.fields.updated_dt': 'Updated at',
  'entities.jwtToken.fields.user_id': 'User ID',
  'entities.jwtToken.title': 'JWT token record',
  'entities.organization.fields.created_dt': 'Created at',
  'entities.organization.fields.deleted_dt': 'Deleted at',
  'entities.organization.fields.details': 'Details (JSON)',
  'entities.organization.fields.id': 'Identifier',
  'entities.organization.fields.name': 'Name',
  'entities.organization.fields.organization': 'Organization',
  'entities.organization.fields.updated_dt': 'Updated at',
  'entities.organization.title': 'Organization',
  'entities.organizationPosition.fields.created_dt': 'Created at',
  'entities.organizationPosition.fields.deleted_dt': 'Deleted at',
  'entities.organizationPosition.fields.id': 'Identifier',
  'entities.organizationPosition.fields.name': 'Name',
  'entities.organizationPosition.fields.organization': 'Organization',
  'entities.organizationPosition.fields.organization_id': 'Subject ID',
  'entities.organizationPosition.fields.slug': 'Slug',
  'entities.organizationPosition.fields.updated_dt': 'Updated at',
  'entities.organizationPosition.title': 'Organization position',
  'entities.organizationStructure.fields.created_dt': 'Created at',
  'entities.organizationStructure.fields.deleted_dt': 'Deleted at',
  'entities.organizationStructure.fields.id': 'Identifier',
  'entities.organizationStructure.fields.name': 'Name',
  'entities.organizationStructure.fields.organization': 'Organization',
  'entities.organizationStructure.fields.organization_id': 'Subject ID',
  'entities.organizationStructure.fields.parent': 'Parent',
  'entities.organizationStructure.fields.parent_id': 'Parent ID',
  'entities.organizationStructure.fields.position': 'Position',
  'entities.organizationStructure.fields.position_id': 'Position ID',
  'entities.organizationStructure.fields.status': 'Status',
  'entities.organizationStructure.fields.subject': 'Subject',
  'entities.organizationStructure.fields.subject_id': 'Subject ID',
  'entities.organizationStructure.fields.type': 'Type',
  'entities.organizationStructure.fields.updated_dt': 'Updated at',
  'entities.organizationStructure.title': 'Organizational structure',
  'entities.organizationStructureInvite.fields.invite_id': 'Invitation ID',
  'entities.organizationStructureInvite.fields.name': 'Name',
  'entities.organizationStructureInvite.fields.organization_id': 'Subject ID',
  'entities.organizationStructureInvite.fields.position_id': 'Position ID',
  'entities.organizationStructureInvite.fields.subject_id': 'Subject ID',
  'entities.organizationStructureInvite.title': 'Invitation (org structure)',
  'entities.organizationStructurePermission.fields.created_dt': 'Created at',
  'entities.organizationStructurePermission.fields.deleted_dt': 'Deleted at',
  'entities.organizationStructurePermission.fields.id': 'Identifier',
  'entities.organizationStructurePermission.fields.org_structure': 'Org structure',
  'entities.organizationStructurePermission.fields.org_structure_id': 'Org structure ID',
  'entities.organizationStructurePermission.fields.organization': 'Organization',
  'entities.organizationStructurePermission.fields.organization_id': 'Subject ID',
  'entities.organizationStructurePermission.fields.permission': 'Permission',
  'entities.organizationStructurePermission.fields.permission_id': 'Permission ID',
  'entities.organizationStructurePermission.fields.subject_org_structure_id': 'Subject org structure ID',
  'entities.organizationStructurePermission.fields.updated_dt': 'Updated at',
  'entities.organizationStructurePermission.title': 'Organization structure permission',
  'entities.permission.fields.created_dt': 'Created at',
  'entities.permission.fields.id': 'Identifier',
  'entities.permission.fields.name': 'Name',
  'entities.permission.fields.slug': 'Slug',
  'entities.permission.fields.updated_dt': 'Updated at',
  'entities.permission.title': 'Permission',
  'entities.pipeline.fields.broker_event': 'Broker event',
  'entities.pipeline.fields.broker_event_id': 'Broker event ID',
  'entities.pipeline.fields.build_dt': 'Build time',
  'entities.pipeline.fields.build_id': 'Build ID',
  'entities.pipeline.fields.created_dt': 'Created at',
  'entities.pipeline.fields.deleted_dt': 'Deleted at',
  'entities.pipeline.fields.id': 'Identifier',
  'entities.pipeline.fields.name': 'Name',
  'entities.pipeline.fields.organization': 'Organization',
  'entities.pipeline.fields.organization_id': 'Subject ID',
  'entities.pipeline.fields.run_dt': 'Run time',
  'entities.pipeline.fields.run_id': 'Run ID',
  'entities.pipeline.fields.status': 'Status',
  'entities.pipeline.fields.updated_dt': 'Updated at',
  'entities.pipeline.title': 'Pipeline',
  'entities.providerContext.fields.created_dt': 'Created at',
  'entities.providerContext.fields.data': 'Data',
  'entities.providerContext.fields.deleted_dt': 'Deleted at',
  'entities.providerContext.fields.id': 'Identifier',
  'entities.providerContext.fields.limit': 'Limit',
  'entities.providerContext.fields.name': 'Name',
  'entities.providerContext.fields.organization': 'Organization',
  'entities.providerContext.fields.organization_id': 'Subject ID',
  'entities.providerContext.fields.service': 'Service',
  'entities.providerContext.fields.service_id': 'Service ID',
  'entities.providerContext.fields.slug': 'Slug',
  'entities.providerContext.fields.type_provider': 'Provider type',
  'entities.providerContext.fields.updated_dt': 'Updated at',
  'entities.providerContext.title': 'Provider context',
  'entities.providerContextClassifier.fields.classifier': 'Classifier',
  'entities.providerContextClassifier.fields.classifier_id': 'Classifier ID',
  'entities.providerContextClassifier.fields.created_dt': 'Created at',
  'entities.providerContextClassifier.fields.deleted_dt': 'Deleted at',
  'entities.providerContextClassifier.fields.id': 'Identifier',
  'entities.providerContextClassifier.fields.name': 'Name',
  'entities.providerContextClassifier.fields.provider': 'Provider',
  'entities.providerContextClassifier.fields.provider_id': 'Provider ID',
  'entities.providerContextClassifier.fields.storage': 'Storage',
  'entities.providerContextClassifier.fields.updated_dt': 'Updated at',
  'entities.providerContextClassifier.title': 'Provider context classifier',
  'entities.resultContextClassifier.fields.context_pipeline': 'Context pipeline',
  'entities.resultContextClassifier.fields.created_dt': 'Created at',
  'entities.resultContextClassifier.fields.data_pipeline': 'Data pipeline',
  'entities.resultContextClassifier.fields.deleted_dt': 'Deleted at',
  'entities.resultContextClassifier.fields.id': 'Identifier',
  'entities.resultContextClassifier.fields.storage_data': 'Storage data',
  'entities.resultContextClassifier.fields.updated_dt': 'Updated at',
  'entities.resultContextClassifier.title': 'Result context classifier',
  'entities.resultScheduler.fields.created_dt': 'Created at',
  'entities.resultScheduler.fields.deleted_dt': 'Deleted at',
  'entities.resultScheduler.fields.detail_scheduler': 'Scheduler detail',
  'entities.resultScheduler.fields.history_running_pipeline': 'Pipeline run record',
  'entities.resultScheduler.fields.history_running_pipeline_id': 'Pipeline run record ID',
  'entities.resultScheduler.fields.id': 'Identifier',
  'entities.resultScheduler.fields.updated_dt': 'Updated at',
  'entities.resultScheduler.title': 'Scheduler job result',
  'entities.role.fields.created_dt': 'Created at',
  'entities.role.fields.id': 'Identifier',
  'entities.role.fields.name': 'Name',
  'entities.role.fields.slug': 'Slug',
  'entities.role.fields.updated_dt': 'Updated at',
  'entities.role.title': 'Role',
  'entities.running.fields.created_dt': 'Created at',
  'entities.running.fields.deleted_dt': 'Deleted at',
  'entities.running.fields.id': 'Identifier',
  'entities.running.fields.name': 'Name',
  'entities.running.fields.slug': 'Slug',
  'entities.running.fields.updated_dt': 'Updated at',
  'entities.running.title': 'Run type',
  'entities.scheduler.fields.created_dt': 'Created at',
  'entities.scheduler.fields.data_pipeline': 'Data pipeline',
  'entities.scheduler.fields.data_pipeline_id': 'Data pipeline ID',
  'entities.scheduler.fields.deleted_dt': 'Deleted at',
  'entities.scheduler.fields.id': 'Identifier',
  'entities.scheduler.fields.name': 'Name',
  'entities.scheduler.fields.pipeline': 'Pipeline',
  'entities.scheduler.fields.pipeline_id': 'Pipeline ID',
  'entities.scheduler.fields.updated_dt': 'Updated at',
  'entities.scheduler.title': 'Scheduler',
  'entities.schemaPipeline.fields.broker_event': 'Broker event',
  'entities.schemaPipeline.fields.broker_event_id': 'Broker event ID',
  'entities.schemaPipeline.fields.created_dt': 'Created at',
  'entities.schemaPipeline.fields.deleted_dt': 'Deleted at',
  'entities.schemaPipeline.fields.id': 'Identifier',
  'entities.schemaPipeline.fields.name': 'Name',
  'entities.schemaPipeline.fields.pipeline': 'Pipeline',
  'entities.schemaPipeline.fields.service': 'Service',
  'entities.schemaPipeline.fields.service_id': 'Service ID',
  'entities.schemaPipeline.fields.type_event': 'Event type',
  'entities.schemaPipeline.fields.type_event_id': 'Event type ID',
  'entities.schemaPipeline.fields.type_exit_event_id': 'Exit event type ID',
  'entities.schemaPipeline.fields.type_running': 'Run type',
  'entities.schemaPipeline.fields.type_running_id': 'Run type ID',
  'entities.schemaPipeline.fields.type_stream_event_id': 'Stream event type ID',
  'entities.schemaPipeline.fields.updated_dt': 'Updated at',
  'entities.schemaPipeline.fields.version': 'Version',
  'entities.schemaPipeline.fields.version_id': 'Version ID',
  'entities.schemaPipeline.title': 'Schema pipeline',
  'entities.service.fields.created_dt': 'Created at',
  'entities.service.fields.deleted_dt': 'Deleted at',
  'entities.service.fields.id': 'Identifier',
  'entities.service.fields.name': 'Name',
  'entities.service.fields.organization': 'Organization',
  'entities.service.fields.organization_id': 'Subject ID',
  'entities.service.fields.slug': 'Slug',
  'entities.service.fields.type_service': 'Service type',
  'entities.service.fields.type_service_id': 'Service type ID',
  'entities.service.fields.updated_dt': 'Updated at',
  'entities.service.title': 'Service',
  'entities.serviceBuild.fields.build_dt': 'Build time',
  'entities.serviceBuild.fields.build_id': 'Build ID',
  'entities.serviceBuild.fields.service_id': 'Service ID',
  'entities.serviceBuild.fields.status': 'Status',
  'entities.serviceBuild.fields.version_id': 'Version ID',
  'entities.serviceBuild.title': 'Service Build',
  'entities.serviceEvent.fields.created_dt': 'Created at',
  'entities.serviceEvent.fields.deleted_dt': 'Deleted at',
  'entities.serviceEvent.fields.id': 'Identifier',
  'entities.serviceEvent.fields.name': 'Name',
  'entities.serviceEvent.fields.organization': 'Organization',
  'entities.serviceEvent.fields.organization_id': 'Subject ID',
  'entities.serviceEvent.fields.slug': 'Slug',
  'entities.serviceEvent.fields.type_service': 'Service type',
  'entities.serviceEvent.fields.type_service_id': 'Service type ID',
  'entities.serviceEvent.fields.updated_dt': 'Updated at',
  'entities.serviceEvent.title': 'Service event type',
  'entities.serviceParams.fields.created_dt': 'Created at',
  'entities.serviceParams.fields.deleted_dt': 'Deleted at',
  'entities.serviceParams.fields.details': 'Details (JSON)',
  'entities.serviceParams.fields.details_id': 'Details template ID',
  'entities.serviceParams.fields.id': 'Identifier',
  'entities.serviceParams.fields.name': 'Name',
  'entities.serviceParams.fields.organization': 'Organization',
  'entities.serviceParams.fields.organization_id': 'Subject ID',
  'entities.serviceParams.fields.slug': 'Slug',
  'entities.serviceParams.fields.type_service': 'Service type',
  'entities.serviceParams.fields.type_service_id': 'Service type ID',
  'entities.serviceParams.fields.updated_dt': 'Updated at',
  'entities.serviceParams.title': 'Service parameter template',
  'entities.serviceRun.fields.run_dt': 'Run time',
  'entities.serviceRun.fields.run_id': 'Run ID',
  'entities.serviceRun.fields.service_id': 'Service ID',
  'entities.serviceRun.fields.status_id': 'Status ID',
  'entities.serviceRun.title': 'Service Run',
  'entities.serviceType.fields.created_dt': 'Created at',
  'entities.serviceType.fields.deleted_dt': 'Deleted at',
  'entities.serviceType.fields.id': 'Identifier',
  'entities.serviceType.fields.name': 'Name',
  'entities.serviceType.fields.slug': 'Slug',
  'entities.serviceType.fields.updated_dt': 'Updated at',
  'entities.serviceType.title': 'Service type',
  'entities.serviceVersion.fields.cache': 'Cache enabled',
  'entities.serviceVersion.fields.code': 'Code',
  'entities.serviceVersion.fields.created_dt': 'Created at',
  'entities.serviceVersion.fields.default': 'Default',
  'entities.serviceVersion.fields.deleted_dt': 'Deleted at',
  'entities.serviceVersion.fields.id': 'Identifier',
  'entities.serviceVersion.fields.input_type_params': 'Input type parameters',
  'entities.serviceVersion.fields.name': 'Name',
  'entities.serviceVersion.fields.npp': 'Sort order',
  'entities.serviceVersion.fields.output_type_params': 'Output type parameters',
  'entities.serviceVersion.fields.service': 'Service',
  'entities.serviceVersion.fields.stream_type_params': 'Stream type parameters',
  'entities.serviceVersion.fields.updated_dt': 'Updated at',
  'entities.serviceVersion.title': 'Service version',
  'entities.serviceVersionBuild.fields.build_dt': 'Build time',
  'entities.serviceVersionBuild.fields.build_id': 'Build ID',
  'entities.serviceVersionBuild.fields.service_id': 'Service ID',
  'entities.serviceVersionBuild.fields.status': 'Status',
  'entities.serviceVersionBuild.title': 'Service Version Build',
  'entities.serviceVersionRun.fields.run_dt': 'Run time',
  'entities.serviceVersionRun.fields.run_id': 'Run ID',
  'entities.serviceVersionRun.fields.service_id': 'Service ID',
  'entities.serviceVersionRun.fields.status': 'Status',
  'entities.serviceVersionRun.title': 'Service Version Run',
  'entities.shareContextStorage.fields.created_dt': 'Created at',
  'entities.shareContextStorage.fields.deleted_dt': 'Deleted at',
  'entities.shareContextStorage.fields.id': 'Identifier',
  'entities.shareContextStorage.fields.organization': 'Organization',
  'entities.shareContextStorage.fields.organization_id': 'Subject ID',
  'entities.shareContextStorage.fields.provider': 'Provider',
  'entities.shareContextStorage.fields.storage': 'Storage',
  'entities.shareContextStorage.fields.storage_id': 'Storage ID',
  'entities.shareContextStorage.fields.updated_dt': 'Updated at',
  'entities.shareContextStorage.title': 'Shared context storage',
  'entities.subject.fields.create_user_id': 'Created by user ID',
  'entities.subject.fields.created_dt': 'Created at',
  'entities.subject.fields.deleted_dt': 'Deleted at',
  'entities.subject.fields.id': 'Identifier',
  'entities.subject.fields.name': 'Name',
  'entities.subject.fields.parent_id': 'Parent ID',
  'entities.subject.fields.type': 'Type',
  'entities.subject.fields.updated_dt': 'Updated at',
  'entities.subject.title': 'Subject',
  'entities.subjectType.fields.created_dt': 'Created at',
  'entities.subjectType.fields.name': 'Name',
  'entities.subjectType.fields.slug': 'Slug',
  'entities.subjectType.fields.subjectTypeId': 'Subject type ID',
  'entities.subjectType.fields.updated_dt': 'Updated at',
  'entities.subjectType.title': 'Subject type',
  'entities.testPipeline.fields.created_dt': 'Created at',
  'entities.testPipeline.fields.data_pipeline': 'Data pipeline',
  'entities.testPipeline.fields.data_pipeline_id': 'Data pipeline ID',
  'entities.testPipeline.fields.deleted_dt': 'Deleted at',
  'entities.testPipeline.fields.distance_service': 'Distance service',
  'entities.testPipeline.fields.distance_service_id': 'Distance service ID',
  'entities.testPipeline.fields.distance_version_service': 'Distance service version',
  'entities.testPipeline.fields.distance_version_service_id': 'Distance service version ID',
  'entities.testPipeline.fields.exit_dt': 'Exit time',
  'entities.testPipeline.fields.id': 'Identifier',
  'entities.testPipeline.fields.is_stopped': 'Stopped',
  'entities.testPipeline.fields.name': 'Name',
  'entities.testPipeline.fields.run_dt': 'Run time',
  'entities.testPipeline.fields.status': 'Status',
  'entities.testPipeline.fields.updated_dt': 'Updated at',
  'entities.testPipeline.title': 'Test pipeline',
  'entities.testResultPipeline.fields.created_dt': 'Created at',
  'entities.testResultPipeline.fields.data_detail_pipeline': 'Data pipeline detail',
  'entities.testResultPipeline.fields.data_detail_pipeline_id': 'Data pipeline detail ID',
  'entities.testResultPipeline.fields.deleted_dt': 'Deleted at',
  'entities.testResultPipeline.fields.distance': 'Distance metric',
  'entities.testResultPipeline.fields.history_running_pipeline': 'Pipeline run record',
  'entities.testResultPipeline.fields.history_running_pipeline_id': 'Pipeline run record ID',
  'entities.testResultPipeline.fields.id': 'Identifier',
  'entities.testResultPipeline.fields.test': 'Test',
  'entities.testResultPipeline.fields.updated_dt': 'Updated at',
  'entities.testResultPipeline.title': 'Test pipeline result',
  'entities.tuneModel.fields.created_dt': 'Created at',
  'entities.tuneModel.fields.data_pipeline': 'Data pipeline',
  'entities.tuneModel.fields.data_pipeline_id': 'Data pipeline ID',
  'entities.tuneModel.fields.deleted_dt': 'Deleted at',
  'entities.tuneModel.fields.distance_service': 'Distance service',
  'entities.tuneModel.fields.distance_service_id': 'Distance service ID',
  'entities.tuneModel.fields.distance_version_service': 'Distance service version',
  'entities.tuneModel.fields.distance_version_service_id': 'Distance service version ID',
  'entities.tuneModel.fields.exit_dt': 'Exit time',
  'entities.tuneModel.fields.id': 'Identifier',
  'entities.tuneModel.fields.model': 'Model',
  'entities.tuneModel.fields.model_id': 'Model ID',
  'entities.tuneModel.fields.name': 'Name',
  'entities.tuneModel.fields.run_dt': 'Run time',
  'entities.tuneModel.fields.status': 'Status',
  'entities.tuneModel.fields.stopped': 'Stopped',
  'entities.tuneModel.fields.updated_dt': 'Updated at',
  'entities.tuneModel.title': 'Fine-tuning job',
  'entities.tuneModelResult.fields.created_dt': 'Created at',
  'entities.tuneModelResult.fields.deleted_dt': 'Deleted at',
  'entities.tuneModelResult.fields.history_running_pipeline': 'Pipeline run record',
  'entities.tuneModelResult.fields.history_running_pipeline_id': 'Pipeline run record ID',
  'entities.tuneModelResult.fields.id': 'Identifier',
  'entities.tuneModelResult.fields.model': 'Model',
  'entities.tuneModelResult.fields.model_id': 'Model ID',
  'entities.tuneModelResult.fields.tuning': 'Tuning job',
  'entities.tuneModelResult.fields.updated_dt': 'Updated at',
  'entities.tuneModelResult.title': 'Tune model result',
  'entities.typeProviderContext.fields.created_dt': 'Created at',
  'entities.typeProviderContext.fields.deleted_dt': 'Deleted at',
  'entities.typeProviderContext.fields.id': 'Identifier',
  'entities.typeProviderContext.fields.name': 'Name',
  'entities.typeProviderContext.fields.organization': 'Organization',
  'entities.typeProviderContext.fields.organization_id': 'Subject ID',
  'entities.typeProviderContext.fields.slug': 'Slug',
  'entities.typeProviderContext.fields.updated_dt': 'Updated at',
  'entities.typeProviderContext.title': 'Provider context type',
  'entities.typeSubjectCommunication.fields.created_dt': 'Created at',
  'entities.typeSubjectCommunication.fields.deleted_dt': 'Deleted at',
  'entities.typeSubjectCommunication.fields.id': 'Identifier',
  'entities.typeSubjectCommunication.fields.name': 'Name',
  'entities.typeSubjectCommunication.fields.organization': 'Organization',
  'entities.typeSubjectCommunication.fields.organization_id': 'Subject ID',
  'entities.typeSubjectCommunication.fields.slug': 'Slug',
  'entities.typeSubjectCommunication.fields.updated_dt': 'Updated at',
  'entities.typeSubjectCommunication.title': 'Communication subject type',
  'entities.user.fields.created_dt': 'Created at',
  'entities.user.fields.deleted_dt': 'Deleted at',
  'entities.user.fields.email': 'Email',
  'entities.user.fields.id': 'Identifier',
  'entities.user.fields.is_active': 'Active',
  'entities.user.fields.login': 'Login (email)',
  'entities.user.fields.name': 'Name',
  'entities.user.fields.parent_id': 'Parent ID',
  'entities.user.fields.password': 'Password',
  'entities.user.fields.role': 'Role',
  'entities.user.fields.updated_dt': 'Updated at',
  'entities.user.fields.user_id': 'User ID',
  'entities.user.title': 'User',
  'entities.userContext.fields.current_user_id': 'Current user ID',
  'entities.userContext.fields.org_structure_id': 'Org structure ID',
  'entities.userContext.fields.org_structure_name': 'Org structure name',
  'entities.userContext.fields.organization_id': 'Subject ID',
  'entities.userContext.fields.organization_name': 'Organization name',
  'entities.userContext.fields.parent_user_id': 'Parent user ID',
  'entities.userContext.title': 'User context',
  'entities.userOrganizationStructure.fields.access_token': 'Access token',
  'entities.userOrganizationStructure.fields.access_token_expired_time': 'Access token expiry',
  'entities.userOrganizationStructure.fields.created_dt': 'Created at',
  'entities.userOrganizationStructure.fields.deleted_dt': 'Deleted at',
  'entities.userOrganizationStructure.fields.id': 'Identifier',
  'entities.userOrganizationStructure.fields.org_structure': 'Org structure',
  'entities.userOrganizationStructure.fields.org_structure_id': 'Org structure ID',
  'entities.userOrganizationStructure.fields.organization': 'Organization',
  'entities.userOrganizationStructure.fields.organization_id': 'Subject ID',
  'entities.userOrganizationStructure.fields.refresh_token': 'Refresh token',
  'entities.userOrganizationStructure.fields.refresh_token_expired_time': 'Refresh token expiry',
  'entities.userOrganizationStructure.fields.updated_dt': 'Updated at',
  'entities.userOrganizationStructure.fields.user_id': 'User ID',
  'entities.userOrganizationStructure.title': 'User in organization structure',
  'entities.versionProviderContext.fields.created_dt': 'Created at',
  'entities.versionProviderContext.fields.data': 'Data',
  'entities.versionProviderContext.fields.default': 'Default',
  'entities.versionProviderContext.fields.deleted_dt': 'Deleted at',
  'entities.versionProviderContext.fields.id': 'Identifier',
  'entities.versionProviderContext.fields.limit': 'Limit',
  'entities.versionProviderContext.fields.name': 'Name',
  'entities.versionProviderContext.fields.npp': 'Sort order',
  'entities.versionProviderContext.fields.provider': 'Provider',
  'entities.versionProviderContext.fields.updated_dt': 'Updated at',
  'entities.versionProviderContext.fields.version': 'Version',
  'entities.versionProviderContext.fields.version_id': 'Version ID',
  'entities.versionProviderContext.title': 'Provider context version',
};
